import { mediasFields } from './composer'

export const getPersonMedias = () => {
  return `query getPersonMedias($slug: String!) {
    personMedias(slug: $slug) {
      firstName
      resume
      lastName
      medias {
        ${mediasFields}
      }
    }
  }`
}
